import { useMutation } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';
import Vehicle from '../../models/vehicle';

export const useCreateVehicle = () => {
  const validateRecaptchaVehicle = async (data: Vehicle) => {
    return vehicleRepository.create(data);
  };
  return useMutation(
    async (data: Vehicle) => await validateRecaptchaVehicle(data),
  );
};
